import { ajustTimeZone } from "./dateFormat";

export default function dateToLine(date: string) {
  const tzFixed = ajustTimeZone(date);

  return tzFixed.toFormat("dd/MM/yyyy HH:mm");
}
